module.exports = __webpack_public_path__ + "static/media/4.19_preview.f3d00a58.png";